import {authServiceSelector} from './AuthService'
import {userServiceSelector} from './UserService'
import {figmaServiceSelector} from './FigmaService'
import {problemServiceSelector} from './ProblemService'
import {projectsServiceSelector} from './ProjectsService'
import {uniqueId} from 'lodash'
import {problemSolutionServiceSelector} from './SingleProblemService'
import {dispatchServiceSelector} from './DispatchService'
import {realtimeServiceSelector} from './RealtimeService'
import {chatServiceSelector} from './ChatService'
import {routerServiceSelector} from './RouterService'
import {projectServiceSelector} from './ProjectService'
import {billingServiceSelector} from './BillingService'
import {configServiceSelector} from './ConfigService'
import {chromeContentServiceSelector} from './Chrome/ChromeContentService'
import {chromePopupServiceSelector} from './Chrome/ChromePopupService'

export class ServiceFactory {
  private selectorToken: string = uniqueId()
  public router = routerServiceSelector(null)

  public get config() {
    return this.getConfigService().config
  }

  public reset = () => {
    this.selectorToken = uniqueId()
  }

  public getAuthService = () => authServiceSelector(this.selectorToken)
  public getUserService = () => userServiceSelector(this.selectorToken)
  public getFigmaService = () => figmaServiceSelector(this.selectorToken)
  public getProblemService = (projectId: string) => problemServiceSelector({token: this.selectorToken, projectId})
  public getProjectsService = () => projectsServiceSelector(this.selectorToken)
  public getProjectService = (projectId: string) => projectServiceSelector({token: this.selectorToken, projectId})
  public getSingleProblemService = (problemId: string | number) => problemSolutionServiceSelector({token: this.selectorToken, problemId})
  public getDispatchService = () => dispatchServiceSelector(null)
  public getRealtimeService = () => realtimeServiceSelector(this.selectorToken)
  public getChatService = (threadId: string) => chatServiceSelector({token: this.selectorToken, threadId})
  public getBillingService = () => billingServiceSelector(this.selectorToken)
  public getConfigService = () => configServiceSelector(this.selectorToken)
  public getChromeContentService = () => chromeContentServiceSelector(this.selectorToken)
  public getChromePopupService = () => chromePopupServiceSelector(this.selectorToken)
}

export default new ServiceFactory()
